import React from "react";
import { Title } from "../../atoms";
import { ValueBox } from "../../molecules";
import { FaCamera, FaEllipsisV, IconName } from "react-icons/fa";
import topDealIcon from "../../../assets/images/topDeal-Icon.svg";
import T from "prop-types";

export const ListRow = ({
  title,
  productName,
  image,
  quantity,
  value,
  isImage,
  onOpenModal,
  isActive,
  isTopDeal,
  isTopDealTcsFunded
}) => {
  return (
    <>
      <div className="miniRow" onClick={onOpenModal}>
        <div className="upperLayerMini">
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <Title text={title} className="subProdCls" />
            <label className={`prod-radio ${isActive ? 'green' : 'gray'}`}>
               <input type="radio" checked= {true} disabled  />
            </label>
          </div>
          
          <Title text={productName} className="prodTitle" />
        </div>
        <div className="dotsMenuMini">
          <FaEllipsisV
            className={"menuIconCls"}
            color={"black"}
            size={20}

            onClick={onOpenModal}
          />
        </div>
      </div>
      <div className="upperLayer" onClick={onOpenModal}>
        <div className="upperLayer0">
          {isImage ? (
            <div className="imageContainer">
              <img src={image} className="productImgCls" />
            </div>
          ) : (
            <div className="emptyImage">
              <FaCamera className={"menuIconCls"} color={"white"} size={20} />
            </div>
          )}
          <div className="upperLayer1">
            {isTopDeal && (<div style={{ display: 'flex', alignItems: 'center' }}>           
            
                  <img src={topDealIcon} style={{ width: '10px', height: '10px', marginLeft:'5px', marginRight:'10px'}} alt="icon" />
                  <div className="green bold" style={{fontSize: '8px'}}>{isTopDealTcsFunded ? 'TCS-Funded' : 'Brand-Funded'}</div>
                  </div>)}
          
          <div style={{ display: 'flex', alignItems: 'center' }}>

            <Title text={title} className="subProdCls" />
            <label className={`prod-radio ${isActive ? 'green' : 'gray'}`}>
               <input type="radio" checked= {true} disabled  />
            </label>
            </div>
            <Title text={productName} className="prodTitle" />
          </div>
        </div>
       
        <div className="rowAlign">
          <ValueBox
            text={"Quantity"}
            value={quantity}
            className="customBoxLayer"
          />
          <ValueBox text={"Value"} value={value} />
        </div>
        <div className="dotsMenu">
          <FaEllipsisV
            className={"menuIconCls"}
            color={"black"}
            size={20}
            onClick={onOpenModal}
          />
        </div>
      </div>
    </>
  );
};

ListRow.T = {
  title: T.string,
  productName: T.string,
  image: T.string,
  quantity: T.string,
  value: T.string,
  onClick: T.func,
  isImage: T.bool,
  isActive: T.bool,
};
